(function () {
    'use strict';

    // @ngInject
    function SecondLevelNavigationInviteControllerCtor($scope, $injector, $stateParams, $state, AnalyticsService, ReferralService, AppStates, UsersManager, moment, AbTestService, Enums,ModelFactory,MemberReferralsManager) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SecondLevelNavigationInviteController';

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.moment = moment;
        this.AnalyticsService = AnalyticsService;
        this.ReferralService = ReferralService;
        this.user = UsersManager.getCurrUser();
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.ModelFactory = ModelFactory;
        this.MemberReferralsManager=MemberReferralsManager ;
        this.loadingReferrals = true;


        // prepare the view model
        this.title = 'My Referrals';

        this.navigationMenuItems = [
            {
                linkTitleKey: 'Refer',
                stateToGoto: AppStates.root_core_navigation_invite_referrals,
                analytics_event: this.AnalyticsService.analytics_events.referrals_refer_tab,
                new_analytics_event: this.AnalyticsService.analytics_events.referral_dashboard_tab
            },
            {
                linkTitleKey: 'Discounts',
                stateToGoto: AppStates.root_core_navigation_invite_partners,
                analytics_event: this.AnalyticsService.analytics_events.my_benefits_partners_tab_button_click,
                new_analytics_event: this.AnalyticsService.analytics_events.my_benefits_partners
            }
        ];

            this.ReferralService.getUserReferralStats()
                .then(function success(stats){
                    if (stats.total_count > 0) {
                        this.navigationMenuItems.splice(1, 0, {
                            linkTitleKey: 'Track',
                            stateToGoto: AppStates.root_core_navigation_invite_track,
                            analytics_event: this.AnalyticsService.analytics_events.referrals_track_tab
                        });
                    }
                }.bind(this))
                .finally(function done() {
                    this.loadingReferrals = false;
                }.bind(this));


    }

    Controllers.SecondLevelNavigationInviteController = Class(Controllers.BaseController, {
        constructor: SecondLevelNavigationInviteControllerCtor,

        onMenuItemClicked: function onMenuItemClicked(menuItem) {
            this.goToState(menuItem.stateToGoto);
            this.AnalyticsService.trackClick(this, menuItem.analytics_event, {
                campaign_uid: this.ReferralService.userCampaignUid
            });

            if (menuItem.new_analytics_event) {
                this.AnalyticsService.trackClick(this, menuItem.new_analytics_event, {
                    campaign_uid: this.ReferralService.userCampaignUid
                });
            }

        }
    });
}());